import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faCopy as farCopy,
  faInfo as farInfo,
  faThumbsUp as farThumbsUp,
  faSirenOn as farSirenOn,
  faExclamation as farExclamation,
  faEye as farEye,
  faEyeSlash as farEyeSlash,
  faSpinnerThird as farSpinnerThird,
  faPaperPlane as farPaperPlane,
  faUserUnlock as farUserUnlock,
  faHandWave as farHandWave,
  faEnvelopeCircleCheck as farEnvelopeCircleCheck,
  faEngineWarning as farEngineWarning,
  faFaceParty as farFaceParty,
  faArrowUpRightFromSquare as farArrowUpRightFromSquare,
  faCalendar as farCalendar,
  faInboxFull as farInboxFull,
  faBolt as farBolt,
  faWandMagicSparkles as farWandMagicSparkles,
  faGear as farGear,
  faArrowUpRight as farArrowUpRight,
} from '@fortawesome/pro-regular-svg-icons'
import {
  faAnalytics as faAnalytics,
  faArrowLeft as fasArrowLeft,
  faArrowRightFromBracket as fasArrowRightFromBracket,
  faBuilding as fasBuilding,
  faCheck as fasCheck,
  faCheckDouble as fasCheckDouble,
  faChevronDown as fasChevronDown,
  faChevronRight as fasChevronRight,
  faCopy as fasCopy,
  faEdit as fasEdit,
  faEnvelopeCircleCheck as fasEnvelopeCircleCheck,
  faExclamation as fasExclamation,
  faExternalLink as fasExternalLink,
  faMessageCheck as fasMessageCheck,
  faMessagePlus as fasMessagePlus,
  faPaperPlane as fasPaperPlane,
  faPaperPlaneTop as fasPaperPlaneTop,
  faPen as fasPen,
  faPlus as fasPlus,
  faSpinnerThird as fasSpinnerThird,
  faTrash as fasTrash,
  faAddressBook as fasAddressBook,
  faUser as fasUser,
  faUserGear as fasUserGear,
  faUserPlus as fasUserPlus,
  faUserShield as fasUserShield,
  faXmark as fasXmark,
  faSensorOn as fasSensorOn,
  faSiren as fasSiren,
  faSirenOn as fasSirenOn,
  faSort as fasSort,
  faSortDown as fasSortDown,
  faSortUp as fasSortUp,
  faCalendarClock as fasCalendarClock,
  faMailbox as fasMailbox,
  faInboxIn as fasInboxIn,
  faSplit as fasSplit,
  faGearComplexCode as fasGearComplexCode,
  faTimelineArrow as fasTimelineArrow,
  faUsers as fasUsers,
  faHouse as fasHouse,
  faDungeon as fasDungeon,
  faGrid2 as fasGrid2,
  faCircleQuestion as fasCircleQuestion,
  faBan as fasBan,
} from '@fortawesome/pro-solid-svg-icons'
import { type App } from 'vue'

export default {
  install(app: App) {
    library.add(
      // Add icons here...
      faAnalytics,
      farCopy,
      farInfo,
      farThumbsUp,
      farSirenOn,
      farExclamation,
      farSpinnerThird,
      farEye,
      farEyeSlash,
      farFaceParty,
      fasAddressBook,
      farBolt,
      fasBuilding,
      fasCheck,
      fasCheckDouble,
      fasChevronDown,
      fasChevronRight,
      fasCopy,
      fasEdit,
      fasEnvelopeCircleCheck,
      fasExclamation,
      fasExternalLink,
      farGear,
      fasMessageCheck,
      fasMessagePlus,
      fasPaperPlane,
      fasPaperPlaneTop,
      fasPen,
      fasPlus,
      fasSiren,
      fasSirenOn,
      fasSensorOn,
      fasSpinnerThird,
      fasTrash,
      fasUser,
      fasUserGear,
      fasUserPlus,
      fasUserShield,
      farWandMagicSparkles,
      fasXmark,
      fasCalendarClock,
      fasMailbox,
      fasInboxIn,
      farCalendar,
      fasSplit,
      fasSort,
      fasSortDown,
      fasSortUp,
      fasGearComplexCode,
      fasTimelineArrow,
      farInboxFull,
      fasUsers,
      fasHouse,
      fasArrowLeft,
      fasArrowRightFromBracket,
      farPaperPlane,
      farUserUnlock,
      farHandWave,
      farEnvelopeCircleCheck,
      fasDungeon,
      farEngineWarning,
      farArrowUpRightFromSquare,
      fasGrid2,
      farArrowUpRight,
      fasCircleQuestion,
      fasBan,
    )
  },
}
